import axios from 'axios';

// N-100 (расширено на clinic-cabinet): токен живёт 7 дней (ACCESS_TOKEN_EXPIRE_MINUTES),
// но Layout.js здесь вообще ничего не запрашивает сам (в отличие от doctor-cabinet), и не
// у всех страниц есть свой .catch() на истёкший токен (см. Support.js, Profile.js — обе
// вечно висели на "Загрузка…" при 401/403, тот же баг, что нашли в админке). Единая точка.
//
// Редиректим ТОЛЬКО если токен реально был выставлен — иначе /login (неверный пароль
// -> 401) ложно словил бы это как истёкшую сессию.
const TOKEN_KEY = 'clinicToken';

// N-125: сессия импersonации (см. AdminSession.js) живёт в sessionStorage — она НЕ
// шарится между вкладками одного origin (в отличие от localStorage). Без этого перехватчика
// AdminSession.js писал бы токен в общий localStorage и молча подменял бы реальную сессию
// клиники, если у неё в этом же браузере уже была открыта своя вкладка кабинета (нашёл
// пользователь: баннер администратора появился в чужой, обычной вкладке). Перехватчик
// подставляет sessionStorage-токен ПРИОРИТЕТНО перед localStorage на каждый запрос — так
// вкладка с impersonation не трогает чужую сессию, даже если инлайн-код страницы читает
// localStorage напрямую при формировании заголовков.
axios.interceptors.request.use((config) => {
  const t = sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = 'Bearer ' + t;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      if (sessionStorage.getItem(TOKEN_KEY)) {
        sessionStorage.clear();
        if (window.location.pathname !== '/login') window.location.href = '/login';
      } else if (localStorage.getItem(TOKEN_KEY)) {
        localStorage.clear();
        if (window.location.pathname !== '/login') window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);
